/**
 * Both parties aged 18 or over, and a valid marriage or civil partnership
 * where that is the basis of the relationship.
 */
import type { EvaluatePredicate } from "./predicate.js";
import { fromFlag } from "./simple.js";

export const both_over_18: EvaluatePredicate = (facts, rule, ctx) => {
  const minimum = ctx.paramFigure(rule, "minimum_age_figure");
  return {
    ...fromFlag(
      facts.relationship.both_over_18,
      `Whether both parties are aged ${minimum} or over is needed.`,
      `The rules ask that both parties are aged ${minimum} or over.`,
    ),
  };
};

/**
 * Applies only where the couple are married or in a civil partnership — for
 * unmarried partners the cohabitation rule carries the relationship instead.
 */
export const married_or_civil_partners: EvaluatePredicate = (facts) => {
  const type = facts.relationship.type;
  if (type === "unmarried_partner") {
    return {
      status: "NOT_APPLICABLE",
      notes: ["The relationship is an unmarried partnership, so the cohabitation requirement applies instead."],
    };
  }
  if (facts.relationship.date_of_marriage === null) {
    return {
      status: "PENDING_EVIDENCE",
      notes: ["The date of the marriage or civil partnership is needed."],
    };
  }
  return { status: "MET" };
};
